import { toast } from 'react-toastify';

import { OpstartSolverResultaat } from '@/components/dialogs/solver/OpstartSolverResultaat';
import { useLoading } from '@/contextProviders/loadingProvider';
import { OpstartSolverOpdracht } from '@/queries/mutaties/opdrachten';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { toastSuccessOptions } from '@/utils/toastOptions';

export interface Executable {
  url: string;
  body: any;
  onSuccess: string;
  onError: string;
}

export function useSolver() {
  const { setLoading } = useLoading();
  const { fetchWithAuth } = useFetchWithAuth();

  const execute = async ({ url, body, onSuccess, onError }: Executable): Promise<OpstartSolverResultaat | null> => {
    try {
      setLoading(true);

      const response = await fetchWithAuth(
        url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        },
        120_000, // 120 seconds timeout
      );

      let responseData: OpstartSolverResultaat | undefined;
      if (response.status === 200) {
        responseData = (await response.json()) as OpstartSolverResultaat;
        console.log(`Response voor OpstartSolver:${JSON.stringify(responseData)}`);
      }

      switch (true) {
        case response.status === 200:
          toast.success(onSuccess, toastSuccessOptions);
          return responseData ?? null;
        case response.status >= 500:
          toast.error(
            'Het uitvoeren van de OpstartSolver is niet gelukt vanwege een technische fout. Probeer het nog een keer of neem contact op met support.',
            { position: 'top-center' },
          );
          break;
        case response.status >= 400:
          toast.error(onError, { position: 'top-center' });
          break;
      }

      return null;
    } catch (error) {
      console.log(error);
      toast.error('Er is een onbekende fout opgetreden. Neem contact op met support.', { position: 'top-center' });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const startenOpstartSolver = async (opdracht: OpstartSolverOpdracht): Promise<OpstartSolverResultaat | null> => {
    const onSuccess = 'OpstartSolver heeft succesvol gedraaid';
    const onError = 'OpstartSolver is niet gelukt.';
    return execute({
      url: '/solver/opstart',
      body: opdracht,
      onSuccess,
      onError,
    });
  };

  return {
    startenOpstartSolver,
  };
}
